import axios from './axios-auth';

const getAuthorizedClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/getauthorizedclients',
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching authorized clients api');
      });
  });

const getTaxReport = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/gettaxreportingdatabasereport',
      method: 'POST',
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get tax reporting database report api');
      });
  });
export { getAuthorizedClients, getTaxReport };
